import { useContext } from 'react';
import { Link } from 'react-router-dom';

import SignIn from '../signin/signin.component';
import SignOut from '../signout/signout.component';
import { MenuContext } from '../../contexts/ui.context';
import { UserContext } from '../../contexts/user.context';

import CancelSVG from '../../vectors/cancel.svg';
import './menu-slide.styles.scss';

const MenuSlide = ({ isOpen, onClose }) => {
  const { currentMenu, setCurrentMenu } = useContext(MenuContext);

  const { currentUser } = useContext(UserContext);

  const options = [
    {
      name: 'HOME',
      linked: '../',
      decor: 'underline'
    },
    {
      name: 'SERVICES',
      linked: '../services',
      decor: 'underline'
    },
    {
      name: 'ABOUT US',
      linked: '../aboutus',
      decor: 'underline'
    },
    // {
    //   name: 'RESOURCES/BLOGS',
    //   linked: '../blogs',
    //   decor: 'inherit'
    // },
    {
      name: 'PRIVACY AND LEGAL',
      linked: '../privacy&legal',
      decor: 'inherit'
    },
    {
      name: 'CONTACT US',
      linked: '../contactus',
      decor: 'inherit'
    },
    {
      name: 'FREE STORE AUDIT',
      linked: '../free-audit',
      decor: 'underline'
    },
    {
      name: 'LAUNCH NEW STORE',
      linked: '../launch-store',
      decor: 'underline'
    },
  ];

  return (
    <div className={`menu-slide ${isOpen ? 'open' : ''}`}>
      <div className="menu-content">
        <span className="close-btn" onClick={onClose}>
          <CancelSVG />
        </span>
        {
          !currentUser ? null
            : <div>💖</div>
        }
        <div className='menu-box'>
          {
            options.map((op) => <Link 
                  key={op.name} 
                  to={op.linked} 
                  // Make menu close on touch screen
                  onClick={
                    () => currentMenu === true 
                      ? setCurrentMenu(false) 
                      : null
                  }
                  style={{ 
                    color: 'inherit',
                    textDecoration: 'none',
                    width: 'auto',
                    margin: '15px'
                  
              }} >
                <span style={{
                  fontSize: window.screen.width <= 1000 ? '18px' : '20px',
                  lineHeight: '2px'
                }}>
                    {op.name}
                  </span>
              </Link>
            )
          }

        {
          !currentUser ? null
            : <Link 
                to={'../profile'} 
                onClick={
                  () => currentMenu === true 
                    ? setCurrentMenu(false) 
                    : null
                }
                style={{ 
                  color: 'inherit',
                  textDecoration: 'none',
                  width: 'auto',
                  margin: '15px'
            }} >
              <span style={{
                fontSize: window.screen.width <= 1000 ? '18px' : '20px',
                lineHeight: '2px'
              }}>
                  MY PROFILE
                </span>
            </Link>
        }
        </div>
        
        { !currentUser ? <SignIn /> : <SignOut /> }
      </div>
    </div>
  );
};

export default MenuSlide;